export const sliceKey = 'instore';
